import { css } from '@emotion/react'
import { Button, Cell, Flow, Grid, Heading, Text } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import { useHistory } from 'react-router'

interface MudancaPathRedirectViewProps {
  titulo: string
  texto: string
  textoBotao: string
  path: string
  image: string
}

export default function MudancaPathRedirectView(props: Readonly<MudancaPathRedirectViewProps>) {
  const { titulo, texto, textoBotao, path, image } = props
  const history = useHistory()

  return (
    <PageContent>
      <Grid style={{ paddingTop: '10rem' }} alignItems='center' justifyContent='center'>
        <Cell size={4}>
          <Flow direction='vertical'>
            <Heading level={1}>{titulo}</Heading>
            <Text>{texto}</Text>
            <Button
              kind='primary'
              onClick={() => history.push(path)}
              style={css`
                width: fit-content;
                padding: 0.6rem 1rem;
              `}
            >
              <Text color='inherit'>{textoBotao}</Text>
            </Button>
          </Flow>
        </Cell>
        <Cell size={6}>
          <img src={image} alt='' />
        </Cell>
      </Grid>
    </PageContent>
  )
}
